<template lang="pug">
v-list(v-if="attachmentCount", color="rgba(255, 0, 0, 0)", flat)
  AttachmentListItemGroup(
    :attachments="attachments",
    v-if="!isPending && !error"
  )
  AttachmentListSkeleton(v-if="isPending", :listLength="attachmentCount")
</template>

<script lang="ts">
import { defineComponent, PropType, ref, Ref, watch } from "vue"
import { ResponseError } from "../interfaces/error.interface"

import AttachmentListItemGroup from "./AttachmentListItemGroup.vue"
import AttachmentListSkeleton from "./AttachmentListSkeleton.vue"
import { Attachment } from "suus-api"
import { topicsApi, eventsApi } from "store/api"
import { PolymorphicType } from "features/common/shared/polymorphic"
export default defineComponent({
  name: "AttachmentList",
  components: { AttachmentListItemGroup, AttachmentListSkeleton },
  props: {
    attachmentCount: { type: Number, required: false, default: 0 },
    attachable: { type: Object as PropType<PolymorphicType>, required: false },
  },
  setup(props) {
    const attachments = ref([] as Attachment[])
    const error: Ref<ResponseError | null> = ref(null)
    const isPending: Ref<boolean> = ref(false)

    async function getAttachments(
      attachableId: string,
      attachableType: string
    ): Promise<void> {
      isPending.value = true
      error.value = null
      try {
        let data = {} as Attachment[]
        if (attachableType === "Topic") {
          data = (await topicsApi.getTopicAttachments(attachableId)).data
        } else if (attachableType === "Event") {
          data = (await eventsApi.getEventAttachments(attachableId)).data
        }
        attachments.value = data
      } catch (err: ResponseError) {
        error.value = err
      } finally {
        isPending.value = false
      }
    }

    watch(
      () => props.attachable,
      (value, oldValue) => {
        isPending.value = true
        setTimeout(() => {
          getAttachments(value.id?.toString(), value.type)
        }, 2500)
      },
      { immediate: true }
    )

    return { attachments, isPending, error }
  },
})
</script>
